import React from 'react';
import "./success.scss";
import { Modal, ModalBody } from "reactstrap";

import { Constants, ImageConstants } from '../../../../constants/constants';
import { getImageSource } from '../../../../utility/image-source'

class Success extends React.Component {
    state = {
    }

    componentDidMount() {
        console.log('', this.props.type)
    }

    onClickInviteMore = (event, key) => {
        this.props.onOk && this.props.onOk()
    }

    render() {

        return (

            <Modal className="cw-custom-modal" isOpen={true} toggle={this.props.close} size={'lg'}>
                <ModalBody >
                    <div className="success">
                        <div className="row">
                            <div className="col text-right">
                                <img alt="" className="close-icon cursor-pointer" onClick={this.props.close} src={getImageSource(ImageConstants.CROSS)} />
                            </div>
                        </div>
                        {
                            this.props.type === Constants.CLICKER_PRACTICE_STANDARD ?
                                <>
                                    <div className="text-center">
                                        <div className="header-text ">
                                            <img alt="" className="icon-50 mr-2" src={getImageSource(ImageConstants.MAIL)} /> <span>{`Practice Created Successfully for ${this.props.class} ${this.props.section}`}</span>
                                        </div>
                                        {/* <div className="text-center">It's shared with <span className="sub-text"> {this.props.students || 0} Students</span>  for {this.props.class} {this.props.section}</div> */}
                                    </div>
                                    <div className="pt-4">
                                        <img alt="" className="divider" src={getImageSource(ImageConstants.DIVIDER)} />
                                    </div>

                                    <div className="text-center pt-4 pb-2">
                                        {/* <div className="text-1 d-inline-block"><h5><strong>{this.props.subTitle ? this.props.subTitle : "Do You want to invite more students to take this assessment?"}</strong></h5></div> */}
                                        <div className="pt-4">
                                            <button className='cw-btn-md d-inline-block cw-btn-primary btn-min-width' onClick={this.props.close}>
                                                <span> Ok</span>
                                            </button>
                                        </div>
                                    </div>
                                </>
                                :
                                <>
                                    <div className="text-center mb-5">
                                        <div className="header-text ">
                                            <img alt="" className="icon-50 mr-2" src={getImageSource(ImageConstants.MAIL)} /> <span>{this.props.title}</span>
                                        </div>
                                        <div className="text-center"><span className="sub-text"> {this.props.students || 0} Students</span>  for {this.props.class} {this.props.section}</div>
                                    </div>
                                    {/* <div className="pt-4">
                                        <img alt="" className="divider" src={getImageSource(ImageConstants.DIVIDER)} />
                                    </div>

                                    <div className="text-center pt-4 pb-2">
                                        <div className="text-1 d-inline-block"><h5><strong>{this.props.subTitle ? this.props.subTitle : "Do You want to invite more students to take this assessment?"}</strong></h5></div>
                                        <div className="pt-4">
                                            <button className='cw-btn-md d-inline-block cw-btn-primary btn-min-width' onClick={this.onClickInviteMore}>
                                                <span> Invite More Students</span>
                                            </button>
                                        </div>
                                    </div> */}
                                </>

                        }


                    </div>
                </ModalBody>
            </Modal >
        );
    }

}

export default Success;